import { graphql } from "relay-runtime"

export const chUndoDuplicatePatientsMutation = graphql`
  mutation chUndoDuplicatePatientsMutation($input: Ch_undoDuplicatePatientsInput!) {
    ch_undoDuplicatePatients(input: $input) {
      ch_Patient {
        id
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
